// Bumped as each selectDm starts. A surface leaves with the visit it opened, so a late
// teardown never clears the rows a newer visit (here or in another surface) shows (#4377).
export class DmVisitCounter {
  #value = 0;

  get current(): number {
    return this.#value;
  }

  bump(): void {
    this.#value += 1;
  }

  reset(): void {
    this.#value = 0;
  }
}
